function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log('Product ID:', productId);

    if (checkbox.checked) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {
                console.log('Added to cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error adding to cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    } else {
        // Handle removing the product from the cart
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: productId,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                console.log('Removed from cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error removing from cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    }
}

// Reload the content of a div with a specific ID using jQuery
function reloadDivContent(divId) {
  console.log("Reloading Div.....")
  $.get(window.location.href, function(data) {
    var newContent = $(data).find('#' + divId).html();
    $('#' + divId).html(newContent);
  });
  console.log("Reloaded Div.....")
  
}


var coll = document.getElementsByClassName("u-accordion-item-title");
        var i;
        for (i = 0; i < coll.length; i++) {
         coll[i].addEventListener("click", function() {
         this.classList.toggle("active");
         var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}